// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.datatables.invoice.Invoice
import org.mifospay.core.model.datatables.invoice.InvoiceEntity

@OptIn(InternalKtorfitApi::class)
public class _InvoiceServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : InvoiceService {
  override fun getInvoices(clientId: Long): Flow<List<Invoice>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "datatables/invoice/${"$clientId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<Invoice>>>(),)!! 
  }

  override fun getInvoice(clientId: Long, invoiceId: Long): Flow<List<Invoice>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "datatables/invoice/${"$clientId".encodeURLPath()}/${"$invoiceId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<Invoice>>>(),)!! 
  }

  override suspend fun addInvoice(clientId: Long, invoice: InvoiceEntity) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "datatables/invoice/${"$clientId".encodeURLPath()}")
        }
        setBody(invoice) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateInvoice(
    clientId: Long,
    invoiceId: Long,
    invoice: InvoiceEntity,
  ) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "datatables/invoice/${"$clientId".encodeURLPath()}/${"$invoiceId".encodeURLPath()}")
        }
        setBody(invoice) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun deleteInvoice(clientId: Long, invoiceId: Long) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "datatables/invoice/${"$clientId".encodeURLPath()}/${"$invoiceId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _InvoiceServiceProvider : ClassProvider<InvoiceService> {
  override fun create(_ktorfit: Ktorfit): InvoiceService = _InvoiceServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createInvoiceService(): InvoiceService = _InvoiceServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
